import moment from 'moment';
import React from 'react';
import ReactTable from '../../../common/UI/ReactTable';

const PharmacistLogs = (props) => {
  const { data } = props;
  const columns = [
    {
      Header: 'Status',
      accessor: 'status',
      disableSortBy: true,
      disableFilters: true,
    },
    {
      Header: 'Date-time',
      accessor: 'date',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <span>{moment(row.original.date).format('DD/MM/YYYY, hh:mm a')}</span>
        );
      },
    },
  ];
  return (
    <div>
      <div className="header_top " style={{ justifyContent: 'space-between' }}>
        <h3>Pharmacist Logs</h3>
      </div>
      <ReactTable
        title="Pharmacist Logs"
        tableColumns={columns}
        tableData={props.data || []}
        seeAll={true}
      />
    </div>
  );
};

export default PharmacistLogs;
